import React, { Suspense } from "react"
import { Outlet, Navigate, useOutletContext } from "react-router-dom"

import { Sidebar } from "@components/page/sidebar"
import { Tabbar } from "@components/page/tabbar"
import { Loading } from "@components/loading"
import { GlobalProps } from "@layout/index"
import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"
import { SIDEBAR_WIDTH } from "@components/page/utils"

import { userRoles } from "../constants"

const StyledBox = styled(Box)(
  ({ theme }) => `
  
  ${theme.breakpoints.up("md")}{
    margin-left: ${SIDEBAR_WIDTH}px;
    border-right: 1px solid ${theme.palette.primary.main}
  }

`
)

const AuthRoutes = () => {
  const parentContext = useOutletContext<GlobalProps>()
  const { auth, show, jumpTo } = parentContext
  return userRoles.includes(auth.user?.role) ? (
    <>
      <Sidebar show={show} jumpTo={jumpTo} />
      <StyledBox>
        <Suspense fallback={<Loading />}>
          <Outlet context={{ ...parentContext }} />
        </Suspense>
      </StyledBox>
      <Tabbar show={show} jumpTo={jumpTo} />
    </>
  ) : (
    <Navigate to="/404" replace />
  )
}

export default AuthRoutes
